module.exports = __webpack_public_path__ + "static/media/electronics2.e39a9511.jpg";